import React from 'react';

export class Topbar extends React.Component{

    constructor(props){
        super(props);
        this.handleBackToStart = this.handleBackToStart.bind(this);
    }
    handleBackToStart(e){
        e.preventDefault();
        this.props.onClick;
    }

    render(){
        return(
            <div id="topbar" className="container-fluid">
                
                    <div className="row">
                        <div className="col-sm-6">
                            <img src="./assets/posa-logo.3da3777da5e290a6a3629bd48726603f.png" alt="pohjola sairaala logo" className="logo" />
                        </div>
                        <div className="col-sm-6 topbar-return">
                         {this.props.children}
                        </div>
                        
                    </div>
                
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Topbar.js